import _ from 'underscore'
import { fireanalytics, firecollection } from 'src/store/firebase'
import http from '@/store/http'

const actions = {
  getData() {},
  async getDocLinksByType(context, data) {
    const { type: docType } = data
    const catcher = (err) => {
      const error = http.catch(err)

      fireanalytics.event('exception', {
        category: 'Docs',
        description: 'Get Docs',
        label: `Get Docs Failed with Error "${error.message}"`,
      })

      return error
    }
    // const role = isInternalUser ? 'internal' : 'external'
    const allDocs = await firecollection.collection('docs', catcher)

    return allDocs.filter((doc) => doc.type === docType)
  },
  async getLinksByType({ dispatch }, data) {
    const links = await dispatch('getDocLinksByType', data)

    fireanalytics.event('goal_completion', {
      category: 'Docs',
      description: 'Get Docs',
      label: `Get Docs by Type "${data.type}"`,
    })

    return _.sortBy(links, 'weight').reverse()
  },
}

export default actions
